import { render, staticRenderFns } from "./PrivacyPolicySheet.vue?vue&type=template&id=788e4c95"
import script from "./PrivacyPolicySheet.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicySheet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports